import Rest from './rest';

const RESOURCE = "product";

export default {

    list: function (params) {
        return Rest.get(RESOURCE, {params});
    },

    downloadLoadTemplate: function () {
        return Rest.downloadExcel(`${RESOURCE}/batch/template`);
    },

    downloadLoadStockTemplate: function () {
        return Rest.downloadExcel(`${RESOURCE}/batch/stock/template`);
    },

    downloadExcel: function (params) {
        return Rest.downloadExcel(`${RESOURCE}/excel`, null, {params});
    },

    getProduct: function (productId) {
        return Rest.get(`${RESOURCE}/${productId}`);
    },

    save: function (productId, data) {
        return Rest.post(`${RESOURCE}/${productId}`, data);
    },
};



// WEBPACK FOOTER //
// ./src/services/ProductService.js